var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectState, projectSlice } from 'app/stores/project';
import { getCurrentPage, getCurrentPageIndex, getPage, } from 'app/stores/selectors';
import { updateViewport } from 'app/stores/viewport/update';
export const selectPage = createAsyncThunk('project/selectPage', (pageId, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const page = getPage(state, pageId);
    if (!page) {
        return Promise.reject(new Error('Invalid page'));
    }
    dispatch(projectSlice.actions.setActivePage({ pageId }));
    updateViewport(page.id, dispatch, getState);
    return Promise.resolve();
}));
export const gotoNextPage = createAsyncThunk('project/gotoNextPage', (_, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const index = getCurrentPageIndex(state);
    const { pages } = getProjectState(state);
    const nextPageId = pages[(index + 1) % pages.length];
    yield dispatch(selectPage(nextPageId));
}));
export const gotoPrevPage = createAsyncThunk('project/gotoPrevPage', (_, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const index = getCurrentPageIndex(state);
    const { pages } = getProjectState(state);
    const nextPageId = pages[(index - 1) % pages.length];
    yield dispatch(selectPage(nextPageId));
}));
export const deletePage = createAsyncThunk('project/deletePage', (params, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const state = getState();
    const { id: pageId } = params;
    const page = (_a = getPage(state, pageId)) !== null && _a !== void 0 ? _a : getCurrentPage(state);
    dispatch(projectSlice.actions.removeSlide({ id: page.id }));
    updateViewport(undefined, dispatch, getState);
}));
